import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { PaymentComponent } from '@sbd-account-portal/app/modules/payment/payment.component';
import {
  OpenQuoteRequestsItem,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/quote-requests.types';

@Component({
  selector: 'sbd-account-portal-frontend-payment-details',
  standalone: true,
  imports: [
    PaymentComponent,
  ],
  templateUrl: './payment-details.component.html',
})
export class PaymentDetailsComponent {
  @Input() selectedQR: OpenQuoteRequestsItem | null = null;
  @Input() queuedQR: OpenQuoteRequestsItem[] = [];
  @Input() subtotal: number = 0;
  @Input() checkoutForm: UntypedFormGroup;

}
